import React from "react";

const Washing_32 = React.forwardRef(
  ({ width = "41", height = "27", viewBox = "0 0 41 27", fill = "none", className }, ref) => {
    return (
      <svg
        ref={ref}
        {...{ width, height, viewBox, fill, className }}
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M10.5439 2H34.1867V4.94058L27.8976 8.54C26.5831 8.51541 25.0774 8.5 23.3682 8.5C19.4063 8.5 16.3221 8.71737 13.8772 9.36798L1.04602 2L0.016932 3.72152L11.4261 10.2729C9.93935 11.0128 8.75537 12.0341 7.77718 13.4246C6.45424 15.3052 5.56513 17.6758 5.00983 19.5249C4.72935 20.4588 4.52826 21.2797 4.397 21.8683C4.38631 21.9162 4.37609 21.9626 4.36631 22.0074L0 24.5064L1.02583 26.2295L4.92143 24H35.3315L39.2592 26.2554L40.2883 24.5339L36.1867 22.1787V6.1062L40.3054 3.74901L39.2795 2.02586L36.1867 3.79594V0H10.5439V2ZM34.1867 7.25084L31.7358 8.65354C31.9939 8.66447 32.2369 8.67556 32.4653 8.68666C33.1797 8.72138 33.7504 8.75618 34.1867 8.78634V7.25084ZM24.4691 10.5022C24.1121 10.5008 23.7452 10.5 23.3682 10.5C20.5778 10.5 18.3363 10.6144 16.5086 10.879L20.1536 12.972L24.4691 10.5022ZM13.6179 11.5316C11.6883 12.1754 10.4107 13.1571 9.41296 14.5754C8.27372 16.1948 7.45865 18.3242 6.92532 20.1001C6.87069 20.282 6.81926 20.4594 6.77095 20.6312L18.1367 14.1263L13.6179 11.5316ZM8.41597 22H31.8485L20.1517 15.2834L8.41597 22ZM34.1867 21.0302L22.1686 14.1291L28.4206 10.5509C30.0533 10.5861 31.3598 10.6353 32.3682 10.6843C33.1487 10.7222 33.7505 10.7601 34.1867 10.7913V21.0302Z"
          fill="black"
        />
      </svg>
    );
  },
);

export default Washing_32;
